import { Component, OnInit } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { ProjectsService } from '../../../services/projects.service';
import * as Projects from '../../../shared/projects.model';

@Component({
  selector: 'app-project-articles',
  templateUrl: './project-articles.component.html',
  styleUrls: ['./project-articles.component.scss']
})
export class ProjectArticlesComponent implements OnInit {

  projectArticles: Projects.ProjectArticle[];
  paginationLimit = 5;
  screenWidth: number;

  constructor(private projectsService: ProjectsService,
              private translate: TranslateService) {}

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.projectsService.fullProjectInfo
      .pipe(
        switchMap(projectInfo => this.projectsService.getProjectArticles(projectInfo?.id))
      )
      .subscribe(projectArticles => {
        this.projectArticles = projectArticles;
        for (const projectArticle of this.projectArticles) {
          projectArticle.read_more_clicked = false;
        }
      });
  }

  showMore() {
    this.paginationLimit += 5;
  }

  toggleReadMore(articleId: number) {
    for (const article of this.projectArticles) {
      if (article.id === articleId) {
        article.read_more_clicked = !article.read_more_clicked;
      }
    }
  }

  get currentLang() {
    return this.translate.currentLang;
  }

}
